import { DNA } from 'react-loader-spinner';

const Loader = () => (
    <>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h4 style={{ color: '#555' }}>Chargement en cours...</h4>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px 0' }}>
        <DNA
        visible={true}
        height="150"
        width="150"
        ariaLabel="dna-loading"
        wrapperClass="dna-wrapper"
        />
    </div>
    </>

);

export default Loader;